import httpClient from '../lib/httpClient';
import type {
  CountryWhitelist,
  CountryWhitelistCreateRequest,
  CountryWhitelistUpdateRequest
} from '../types/CountryWhitelist';

/**
 * Fetch all country whitelist presets from the database.
 */
export const fetchCountryWhitelists = async (): Promise<CountryWhitelist[]> => {
  try {
    const response = await httpClient.get('/api/v1/reels-cms/country-whitelist');
    return response || [];
  } catch (error) {
    console.error('Failed to fetch country whitelists:', error);
    return [];
  }
};

/**
 * Fetch a specific country whitelist by ID.
 */
export const fetchCountryWhitelistById = async (id: string): Promise<CountryWhitelist | null> => {
  try {
    const response = await httpClient.get(`/api/v1/reels-cms/country-whitelist/${id}`);
    return response;
  } catch (error) {
    console.error(`Failed to fetch country whitelist ${id}:`, error);
    return null;
  }
};

/**
 * Create a new country whitelist preset.
 */
export const createCountryWhitelist = async (
  request: CountryWhitelistCreateRequest
): Promise<CountryWhitelist> => {
  const response = await httpClient.post('/api/v1/reels-cms/country-whitelist', request);
  return response;
};

/**
 * Update an existing country whitelist preset.
 */
export const updateCountryWhitelist = async (
  id: string,
  request: CountryWhitelistUpdateRequest
): Promise<CountryWhitelist> => {
  const response = await httpClient.put(`/api/v1/reels-cms/country-whitelist/${id}`, request);
  return response;
};

/**
 * Delete a country whitelist preset.
 */
export const deleteCountryWhitelist = async (id: string): Promise<void> => {
  await httpClient.delete(`/api/v1/reels-cms/country-whitelist/${id}`, {});
};
